import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

// import { GrClose } from "react-icons/gr"
import done from "../../../assets/media/checkout/done.png"
import doneDesktop from "../../../assets/media/checkout/doneDesktop.png"

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: "0.5rem"
};

export default function CheckoutModal(props) {

    return (
        <div>
            <Modal
                open={props.isOpen}
                onClose={() => props.handleCloseModal()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="!w-[315px] lg:!w-[610px] lg:!px-[87px] lg:!py-[74px]">

                    <div className=" flex flex-col items-center justify-center">
                        <img src={window.innerWidth >= 1024 ? doneDesktop : done} className="object-contain w-[75px] lg:w-[174px] " alt="" />
                        <div className="content lg:mt-[6.5px] text-center">
                            <h3 className=' text-[24px] leading-[55px] font-[700] lg:text-[32px] lg:leading-[35px] lg:mt-[50px]'>Congragulations!</h3>
                            <p className='text-sm mt-1 text-[16px] leading-[29px] lg:text-[22px] lg:leading-[34px] lg:mt-[31px]'>Your account has been successfully created. Please verify your email by clicking the link sent to you.</p>
                        </div>
                    </div>

                </Box>
            </Modal>
        </div>
    );
}
